import { useEffect, useState } from 'react';
import { getLanLoc } from './LangFunc';
import { useLocation } from 'react-router-dom';
import { apiMain } from '../../App';
import { PostDataPromise } from './SendingData';

export default function SetHeaders () {
    const location = useLocation();
    let {isEn: lan, isSet} = getLanLoc(location.pathname);
    const [baseData, setBaseData] = useState({
        ip: "",
        useragent: "",
        country: "",
        city: "",
    })
    const [stateHistory, setStateHistory] = useState([]);
    const template = {
        url: "/",
        vi_code: "",
        time: "/",
        Vi_Code: "",
    }
    
    
    useEffect(() => {
        if(lan){
            document.documentElement.style.setProperty('--font', 'var(--font-en)');
        } else {
            document.documentElement.style.setProperty('--font', 'var(--font-fa)');
        }
        if(isSet){
            if(lan){
                localStorage.setItem("luxtrip-lang", "en")
            } else {
                localStorage.setItem("luxtrip-lang", "fa")
            }
        }
        if(location.pathname.search("/admin/") !== -1){
            document.documentElement.style.setProperty('--font', 'var(--font-fa)');
        }
        window.scrollTo({
            top: 0,
            behavior: 'smooth',
        });
        return () => {
        }
      }, [location.pathname]);
    return "";
}

export const setMetaTags = (title, description, noindex = "", canonical = "") => {
    document.title = title;
    
    let meta = document.querySelector('meta[name=description]');
    if(meta){
        meta.remove();
    }
    let metaR = document.querySelector('meta[name=robots]');
    if(metaR){
        metaR.remove();
    }
    let link = document.querySelector('link[rel=canonical]');
    if(link){
        link.remove();
    }

    let desc = document.createElement("meta");
    desc.name = 'description';
    desc.content = description;
    document.getElementsByTagName('head')[0].appendChild(desc);

    if(noindex.length > 0){
        let robots = document.createElement("meta");
        robots.name = 'robots';
        robots.content = "noindex,nofollow";
        document.getElementsByTagName('head')[0].appendChild(robots);
    }
    if(canonical.length > 0){
        let cano = document.createElement("link");
        cano.rel = 'canonical';
        cano.href = canonical;
        document.getElementsByTagName('head')[0].appendChild(cano);
    }
}

export const resetReachData = () => {
    let mainData = document.querySelector("script[type='application/ld+json']");
    if(!mainData){
        mainData = document.createElement("script");
        mainData.type = "application/ld+json";
    }
    let content = mainData.innerText;
    const innerContent = {
        "@context":"https://schema.org",
        "@graph":[]
    }
    if(!content){
        content = JSON.stringify(innerContent);
    }
    let schemaData = JSON.parse(content);
    if(schemaData["@graph"].length){
        schemaData["@graph"] = [];
    }
    setReachData(schemaData);
}

export const updateWebsiteData = (lan) => {
    let webSite = {
        "@type":"WebSite",
        "@id":"https://luxintrip.com/#website",
        "url":"https://luxintrip.com/en",
        "name":"Luxintrip",
        "description":"Guaranteeing the quality of your trip - booking all kinds of travel and tourism tours to all destinations in the world",
        "publisher":{"@id":"https://luxintrip.com/#organization"},
        "alternateName":"لوکسین تریپ",
        "inLanguage":"en"
    }
    if(lan === "fa"){
        webSite = {
            "@type":"WebSite",
            "@id":"https://luxintrip.com/#website",
            "url":"https://luxintrip.com/fa",
            "name":"لوکسین تریپ",
            "description":"ضامن کیفیت سفر شما - رزرو انواع تور مسافرتی و گردشگری به تمام مقاصد جهان",
            "publisher":{"@id":"https://luxintrip.com/#organization"},
            "alternateName":"Luxintrip",
            "inLanguage":"fa-IR"
        }
    }
    
    setReachDataType("WebSite", webSite);
}
export const updateOrgData = (lan) => {
    let org = {
        "@type":"Organization",
        "@context": "https://schema.org",
        "@id":"https://luxintrip.com/#organization",
        "name":"Luxintrip",
        "alternateName":"لوکسین تریپ",
        "description": "Luxin Trip platform, an easy solution for tour brokers and travel agencies »»» Transfer funds - Purchase broker services - Management and monitoring of tourism tours - Accounting and management reports",
        "url":"https://luxintrip.com/",
        "image": "https://luxintrip.com/base/Luxintrip(Green).svg",
        "logo": "https://luxintrip.com/base/Luxintrip(Green).svg",
        "sameAs": ["https://instagram.com/luxin_trip"],
        "email": "support@luxintrip.com",
        "telephone": "+98 21 8850 3856",
    }
    if(lan === "fa"){
        org = {
            "@type":"Organization",
            "@context": "https://schema.org",
            "@id":"https://luxintrip.com/#organization",
            "name":"لوکسین تریپ",
            "alternateName":"Luxintrip",
            "description": "پلتفرم لوکسین تریپ، راه حل آسان برای کارگزاران تور و آژانس های گردشگری »»» انتقال وجه - خرید خدمات کارگزار - مدیریت و نظارت بر تور گردشگری- گزارش های حسابداری و مدیریتی",
            "url":"https://luxintrip.com/",
            "image": "https://luxintrip.com/base/Luxintrip(Green).svg",
            "logo": "https://luxintrip.com/base/Luxintrip(Green).svg",
            "sameAs": ["https://instagram.com/luxin_trip"],
            "email": "support@luxintrip.com",
            "telephone": "+98 21 8850 3856",
        }
    }
    setReachDataType("Organization", org);
}
export const updateOrgDataBussiness = (lan) => {
    let org = {
        "@type":"Organization",
        "@context": "https://schema.org",
        "@id":"https://luxintrip.com/#organization",
        "name":"Luxintrip",
        "alternateName":"لوکسین تریپ",
        "description": "Luxin Trip platform, an easy solution for tour brokers and travel agencies »»» Transfer funds - Purchase broker services - Management and monitoring of tourism tours - Accounting and management reports",
        "url":"https://luxintrip.com/en",
        "image": "https://luxintrip.com/base/Luxintrip(Green).svg",
        "logo": "https://luxintrip.com/base/Luxintrip(Green).svg",
        "sameAs": ["https://instagram.com/luxin_trip"],
        "email": "support@luxintrip.com",
        "telephone": "+98 21 8850 3856",
        "contactPoint": [
            {
                "@type": "ContactPoint",
                "url" : "https://luxintrip.com/en/contactus",
                "contactType": "customer service",
                "areaServed" : "IR",
                "availableLanguage": [
                    {
                        "@type": "Language",
                        "name": "English"
                    },
                    {
                        "@type": "Language",
                        "name": "Persian"
                    },
                ],
                "hoursavailable" : {
                    "@type": "openingHoursSpecification",
                    "dayofweek" : ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "all day"],
                    "opens":"00:00",
                    "closes":"23:59"
                },
            }
        ]
    }
    if(lan === "fa"){
        org = {
            "@type":"Organization",
            "@context": "https://schema.org",
            "@id":"https://luxintrip.com/#organization",
            "name":"لوکسین تریپ",
            "alternateName":"Luxintrip",
            "description": "پلتفرم لوکسین تریپ، راه حل آسان برای کارگزاران تور و آژانس های گردشگری »»» انتقال وجه - خرید خدمات کارگزار - مدیریت و نظارت بر تور گردشگری- گزارش های حسابداری و مدیریتی",
            "url":"https://luxintrip.com/fa",
            "image": "https://luxintrip.com/base/Luxintrip(Green).svg",
            "logo": "https://luxintrip.com/base/Luxintrip(Green).svg",
            "sameAs": ["https://instagram.com/luxin_trip"],
            "email": "support@luxintrip.com",
            "telephone": "+98 21 8850 3856",
            "contactPoint": [
                {
                    "@type": "ContactPoint",
                    "url" : "https://luxintrip.com/fa/contactus",
                    "contactType": "customer service",
                    "areaServed" : "IR",
                    "availableLanguage": [
                        {
                            "@type": "Language",
                            "name": "English"
                        },
                        {
                            "@type": "Language",
                            "name": "Persian"
                        },
                    ],
                    "hoursavailable" : {
                        "@type": "openingHoursSpecification",
                        "dayofweek" : ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday", "all day"],
                        "opens":"00:00",
                        "closes":"23:59"
                    },
                }
            ]
        }
    }
    setReachDataType("Organization", org);
}
const getReachData = () => {
    let mainData = document.querySelector("script[type='application/ld+json']");
    if(!mainData){
        mainData = document.createElement("script");
        mainData.type = "application/ld+json";
    }
    let content = mainData.innerText;
    const innerContent = {
        "@context":"https://schema.org",
        "@graph":[]
    }
    if(!content){
        content = JSON.stringify(innerContent);
    }
    return JSON.parse(content);
}
export const setReachDataType = (type, data) => {
    let schemaData = getReachData();
    let findIndex = schemaData["@graph"].findIndex((v) => v["@type"] === type)
    if(findIndex === -1){
        schemaData["@graph"].push(data);
    } else {
        schemaData["@graph"][findIndex] = data;
    }
    setReachData(schemaData)
}
const setReachData = (data) => {
    let mainData = document.querySelector("script[type='application/ld+json']");
    if(mainData){
        mainData.remove();
    }
    let newData = document.createElement("script");
    newData.type = "application/ld+json";
    newData.innerText = JSON.stringify(data)
    document.getElementsByTagName('head')[0].appendChild(newData);
}

export const makeBreadCrumbReach = (lang, breadData) => {
    // first remove
    // let mainData = document.querySelector("script[type='application/ld+json']");
    // if(mainData){
    //     mainData.remove();
    // }
    // // then make with new data
    // let newData = document.createElement("script");
    // newData.type = "application/ld+json";

    

    
    // const innerContent = {
    //     "@context":"https://schema.org",
    //     "@graph":[]
    // }
    // if(breadData){
    //     innerContent['@graph'].push(breadData)
    // }
    
    // innerContent['@graph'].push(
    //     webSite,
    //     org
    // )
    // newData.innerText = JSON.stringify(innerContent)
    // document.getElementsByTagName('head')[0].appendChild(newData);
}


let viewData = {
    baseData: {
        ip: "",
        country: "",
        city: "",
        useragent: "",
        timezone: ""
    },
    stateHistory: [],
    clickHistory: [],
};

export const makeViewEvent = async (vi_code, vi_req) => {
    let newurl = window.location.pathname
    let newBaseData = viewData.baseData;
    if(viewData.baseData.ip === ""){
        let loc2;
        try{
            loc2 = await fetch('https://ipcheck.luxinluxshop.workers.dev/');
        } catch(e){
            return;
        }
        let data2 = JSON.parse(await loc2.text());
        newBaseData = {
            ip: data2.ip,
            country: data2.country,
            city: data2.city,
            timezone: data2.timezone,
            useragent: window.navigator.userAgent,
        }
        viewData.baseData = newBaseData
    }

    // validate history;
    let nowTime = Date.now()
    let findUrl = viewData.stateHistory.findIndex((v) => {
        if(v.time < nowTime - (60*60*1000)){
            return false
        }
        if(v.url === newurl){
            return true;
        }
    });
    if(findUrl === -1){
        // save history data for validation;
        viewData.stateHistory.push({
            url: newurl,
            time: nowTime,
            Vi_Code: "",
        })
        ///api/v1/campaign/viewevent/insert
        let formdata = new FormData();
        let userdata = (localStorage.getItem("luxtrip-user")) ? JSON.parse(localStorage.getItem("luxtrip-user")): {};
        if(userdata.U_CODE){
            formdata.append("U_CODE", userdata.U_CODE);
        }

        formdata.append("Views_Ev_IP", newBaseData.ip);
        formdata.append("Views_Ev_Agent", newBaseData.useragent);
        formdata.append("Views_Ev_Country", newBaseData.country);
        formdata.append("Views_Ev_Zone", newBaseData.timezone);
        formdata.append("Vi_Code", vi_code);
        if(vi_req === undefined){
            formdata.append("Vi_Required", "");
        } else {
            formdata.append("Vi_Required", vi_req);
        }
        formdata.append("Views_Ev_Type", 0);

        let response = await PostDataPromise(apiMain + "/api/v1/campaign/viewevent/insert", formdata);
    }
}

export const makeClickEvent = async (Agancy_Camp_Id) => {
    let newBaseData = viewData.baseData;
    if(viewData.baseData.ip === ""){
        let loc2;
        try{
            loc2 = await fetch('https://ipcheck.luxinluxshop.workers.dev/');
        } catch(e){
            return;
        }
        let data2 = JSON.parse(await loc2.text());
        newBaseData = {
            ip: data2.ip,
            country: data2.country,
            city: data2.city,
            timezone: data2.timezone,
            useragent: window.navigator.userAgent,
        }
        viewData.baseData = newBaseData
    }

    // validate history;
    let nowTime = Date.now()
    let findUrl = viewData.clickHistory.findIndex((v) => {
        if(v.time < nowTime - (60*60*1000)){
            return false
        }
        if(v.Agancy_Camp_Id === Agancy_Camp_Id){
            return true;
        }
    });
    if(findUrl === -1){
        // save history data for validation;
        viewData.clickHistory.push({
            Agancy_Camp_Id: Agancy_Camp_Id,
            time: nowTime,
        })

        let formdata = new FormData();
        let userdata = (localStorage.getItem("luxtrip-user")) ? JSON.parse(localStorage.getItem("luxtrip-user")): {};
        if(userdata.U_CODE){
            formdata.append("U_CODE", userdata.U_CODE);
        }

        formdata.append("Agancy_Camp_Ev_IP", newBaseData.ip);
        formdata.append("Agancy_Camp_Ev_Agent", newBaseData.useragent);
        formdata.append("Agancy_Camp_Ev_Country", newBaseData.country);
        formdata.append("Agancy_Camp_Ev_Zone", newBaseData.timezone);
        formdata.append("Agancy_Camp_Id", Agancy_Camp_Id);

        formdata.append("Agancy_Camp_Ev_Type", 2);

        let response = await PostDataPromise(apiMain + "/api/v1/agencies/agency_camp_event/insert", formdata);
    }
}